const config = {
  development: {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8085'
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL || 'https://www.flowdino.com'
  }
};

const environment = process.env.REACT_APP_ENV || 'development';

// Utilisez une URL absolue complète pour contourner le proxy webpack
export const API_URL = `${config[environment].API_URL}/api`;

export const API_ENDPOINTS = {
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password'
};

// Logs seulement en développement
if (environment === 'development') {
  console.log('[CONFIG] Environment:', environment);
  console.log('[CONFIG] Base API URL:', config[environment].API_URL);
  console.log('[CONFIG] Full API URL:', API_URL);
}
